// Meta Pixel utility functions
// Pixel ID: 1460293155735606

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v

  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '1460293155735606')
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(
      'track',
      'AddToCart',
      params || {
        content_name: '3AM Otra Vez - Protocolo de Sueño',
        content_ids: ['51116124078378'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      },
    )
  }
}
